module.exports = __webpack_public_path__ + "static/img/delete-vendor.d83af9f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/admin/delete-vendor.svg
// module id = uFGk
// module chunks = 1